const errorTrack = modalId => {
  if (window.Genesys.webmessenger.toggleMessenger != null)
    window.Genesys.webmessenger.toggleMessenger();
  window.Genesys('command', 'Journey.trackClickEvents', {
    clickEvents: [
      {
        selector: modalId,
        eventName: 'btn_chatNow_clicked',
      },
    ],
  });
};

export default errorTrack;
